import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { hideMobileNav, showMobileNav, useStore } from '../../Store'
import { disablePageScroll, enablePageScroll } from '../../utils/utils'
import { MenuToggleMain, MenuToggleBar, MenuToggleWrapper } from './index.style'

const MenuToggle = () => {
  const [store, dispatch] = useStore()
  const { mobileNavIsOpen } = store
  const toggleRef = useRef()
  const barRefA = useRef()
  const barRefB = useRef()
  const barRefC = useRef()

  useEffect(() => {
    const tlOpen = gsap.timeline({ paused: true })
    const tlClose = gsap.timeline({ paused: true })

    tlOpen
      .to(barRefA.current, {
        y: 0,
        rotate: 45,
        duration: 0.2,
        ease: 'power2.inOut',
      })
      .to(
        barRefB.current,
        {
          opacity: 0,
          duration: 0.2,
          ease: 'power2.inOut',
        },
        0
      )
      .to(
        barRefC.current,
        {
          y: 0,
          rotate: -45,
          duration: 0.2,
          ease: 'power2.inOut',
        },
        0
      )

    tlClose
      .to(barRefA.current, {
        y: -8,
        rotate: 0,
        duration: 0.2,
        ease: 'power2.inOut',
      })
      .to(
        barRefB.current,
        {
          opacity: 1,
          duration: 0.2,
          ease: 'power2.inOut',
        },
        0
      )
      .to(
        barRefC.current,
        {
          y: 8,
          rotate: 0,
          duration: 0.2,
          ease: 'power2.inOut',
        },
        0
      )

    if (mobileNavIsOpen) {
      disablePageScroll()
      tlOpen.play()
    } else {
      enablePageScroll()
      tlClose.play()
    }

    return () => {
      tlOpen.kill()
      tlClose.kill()
    }
  }, [mobileNavIsOpen])

  const handleClick = () => {
    if (mobileNavIsOpen) {
      hideMobileNav(dispatch)
    } else {
      showMobileNav(dispatch)
    }
  }

  return (
    <MenuToggleWrapper ref={toggleRef}>
      <MenuToggleMain onClick={handleClick} aria-label="Toggle menu">
        <MenuToggleBar ref={barRefA} />
        <MenuToggleBar ref={barRefB} />
        <MenuToggleBar ref={barRefC} />
      </MenuToggleMain>
    </MenuToggleWrapper>
  )
}

export default MenuToggle
